import { OrderPaymentDetails, OrderPaymentMethod } from './order-payment-method';

export class OrderPaymentWithGooglePay extends OrderPaymentMethod {
    public async generatePaymentDetails(details: OrderPaymentDetails) {
        const { paymentMethod } = details;

        if (paymentMethod?.vendorService === OLO.Enums.PAYMENT_VENDOR_SERVICE.GOOGLE_PAY && Boolean(paymentMethod?.googlePaymentData?.PaymentData)) {
            this._extendExecutePaymentModel(details);

            this._executePaymentModel.GooglePayToken = {
                PaymentData: {
                    ...paymentMethod.googlePaymentData.PaymentData,
                },
            };

            if (this._executePaymentModel.PaymentProvider === OLO.Enums.PAYMENT_PROVIDER.STRIPE) {
                this._executePaymentModel.GooglePayToken = null;
            }

            this._executePaymentModel.Token = details.paymentMethod.googlePaymentData?.PaymentData?.Token;
            this._executePaymentModel.CreditCardType = OLO.Enums.CREDIT_CARD_TYPES.GOOGLE_PAY;

            this._executePaymentModel.PaymentAccountId = null;

            return this._executePaymentModel;
        }

        if (this._next) {
            return this._next.generatePaymentDetails(details);
        }

        return this._executePaymentModel;
    }
}
